import { SeparatorBlue600 } from "../../../../../../components/styled-components";
import "./CategoryDetailMoreInformationComponent.scss";

/**
 * @function CategoryDetailMoreInformationComponent component for rendering contact information
 * @returns {JSX.Element}
 */
const CategoryDetailMoreInformationComponent = ( { info } ) => {
    const { intestazione, indirizzo, email, telefono, fax } = info ? info : {};
    return (
        info ? ( <div>
            <SeparatorBlue600 className="mb-3"></SeparatorBlue600>
            <div className="CategoryDetailMoreInformationComponent">
                <div className="CategoryDetailMoreInformationComponent__title" role="contentinfo" tabIndex="0" aria-label={"Per maggiori informazioni"}> Per maggiori informazioni:</div>
                <div className="CategoryDetailMoreInformationComponent__descrizione mt-2" role="contentinfo" tabIndex="0" aria-label={intestazione}>{ intestazione }</div>
                <ul className="CategoryDetailMoreInformationComponent__list mt-4">
                    { indirizzo ?
                    <li className="CategoryDetailMoreInformationComponent__listItem">
                        <div className="d-flex">
                            <span className="material-icons-outlined"  role="contentinfo" tabIndex="0" aria-label={"location_on"}>location_on</span>
                            <div role="contentinfo" tabIndex="0" aria-label={indirizzo} >{ indirizzo }</div>
                        </div>
                    </li>
                    : ""}
                    { email ?
                    <li className="CategoryDetailMoreInformationComponent__listItem">
                        <div className="d-flex">
                            <span className="material-icons-outlined" role="contentinfo" tabIndex="0" aria-label={"email"}>email</span>
                            <div role="contentinfo" tabIndex="0" aria-label={`E-mail: ${email}`}>E-mail: { email }</div>
                        </div>
                    </li>
                    : ""}
                    { telefono ?
                    <li className="CategoryDetailMoreInformationComponent__listItem">
                        <div className="d-flex">
                            <span className="material-icons-outlined" role="contentinfo" tabIndex="0" aria-label={"call"}>call</span>
                            <div role="contentinfo" tabIndex="0" aria-label={`Telefono: ${telefono}`}>Telefono: { telefono }</div>
                        </div>
                    </li>
                    : ""}
                    { fax ? 
                    <li className="CategoryDetailMoreInformationComponent__listItem">
                        <div className="d-flex">
                            <span className="material-icons-outlined" role="contentinfo" tabIndex="0" aria-label={"fax"}>fax</span>
                            <div tabIndex="0" aria-label={`Fax: ${fax}`}>Fax: { fax }</div>
                        </div>
                    </li>
                    : ""}
                </ul>
            </div>
        </div> ) : null
    );
};

CategoryDetailMoreInformationComponent.defaultProps = {};

export default CategoryDetailMoreInformationComponent;